import { useContext } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { ArrowSquareOutIcon } from '@phosphor-icons/react'

import { Text } from '@reveni-io/reveni-ui'

import AppContext from '@/common/context/app.context'

import OptionCard from '../OptionCard/OptionCard'
import { orderAlertDefaultMessage } from './constants'
import * as Styles from './styles'

const OrderOption = ({ order, selected, onClick, alertMessage }) => {
  const { t, i18n } = useTranslation()
  const { info } = useContext(AppContext)

  const defaultAlertMessage = <Trans i18nKey={orderAlertDefaultMessage} components={{ bold: <strong /> }} />

  const handleLinkClick = event => {
    event.stopPropagation()
  }

  return (
    <OptionCard
      selected={selected}
      onClick={onClick}
      alertType="info"
      alertMessage={alertMessage || defaultAlertMessage}
    >
      <Styles.Header>
        <Text type="bodyMBold">#{order.number}</Text>
        <Styles.Link href={order.external_url} target="_blank" rel="noreferrer" onClick={handleLinkClick}>
          {t('Ver pedido')}
          <ArrowSquareOutIcon size={14} />
        </Styles.Link>
      </Styles.Header>
      <Text type="bodySRegular">
        {new Intl.DateTimeFormat(i18n.language, {
          dateStyle: 'medium',
          timeZone: info?.selectedStore?.timezone,
        }).format(new Date(order.date))}
      </Text>
    </OptionCard>
  )
}

export default OrderOption
